module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-2-medium-ebf51edc20f9db4015fc81d732699925.jpg";